import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FilterType } from '../../../../../core/enums/filter-type';
import { Filter } from '../../../../../core/models/filter';
import { BoolFilterType } from '../../../../../core/services/api-services';
import { BaseFilterComponent } from '../base-filter.component';

@Component({
  selector: 'app-bool-filter',
  templateUrl: './bool-filter.component.html',
  styleUrls: ['./bool-filter.component.scss']
})
export class BoolFilterComponent extends BaseFilterComponent<BoolFilterType> implements OnInit {
  // Initial Input
  @Input() labelTrue: string = '';
  @Input() labelFalse: string = '';
  @Input() useLabels = false;
  filterType: FilterType = FilterType.Bool;

  boolForm = new FormGroup({
    value: new FormControl('', [Validators.required])
  });

  constructor(private readonly formBuilder: FormBuilder) {
    super();
  }


  ngOnInit(): void {
    this.currentValue
      .unsubscribeOnDestroy(this)
      .subscribe(value => {
        if (value) {
          this.filterChanged.emit({ filter: value, filterType: this.filterType, propertyName: this.propertyName });
          this.activeFilterField = value !== null;

          this.boolControl.setValue(value.values[0]);
        }
      });

    if (this.initialValue) {
      this.currentValue.next(this.initialValue);
    }
  }

  clearFilter(): void {
    this.currentValue.next(null);
    this.activeFilterField = this.currentValue.value !== null;
    this.boolForm.reset();
  }

  onSubmit($event): void {
    // Trigger form validation for untouched fields
    this.boolForm.markAllAsTouched();

    if (this.boolForm.valid) {
      const model: Filter<BoolFilterType> = {
        filterType: BoolFilterType.Equals,
        values: [this.boolControl.value, null] as any[],
        name: this.propertyName
      };

      this.currentValue.next(model);
    }
    else {
      $event?.stopPropagation();
    }
  }

  onCancel(): void {
  }

  get boolControl(): FormControl {
    return this.boolForm.controls.value as FormControl;
  }
}
